// Domain
import { InvalidPassword } from '../../../exceptions';

const REGEX_PASSWORD = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

export default class MinimalRequirementsRule {
  static validate(password: string) {
    const minimal_requirements = REGEX_PASSWORD.test(password);

    if (!minimal_requirements) {
      throw new InvalidPassword('InvalidPassword');
    }
  }
}
